function About() {

    return (
        <p>About our shit</p>
    )

}

export default About;